"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var speechstream_1 = __importDefault(require("./speechstream"));
var useSpeechStream = function (isSpanishContent) {
    var _a, _b;
    if (isSpanishContent === void 0) { isSpanishContent = false; }
    var _c = (0, react_1.useState)(false), playing = _c[0], setPlaying = _c[1];
    var isAvailable = !!((_a = window.speechstream) === null || _a === void 0 ? void 0 : _a.speechTools);
    var validateSpeechstreamIsActive = function () {
        var _a;
        if (!window.speechstream) {
            (0, speechstream_1.default)();
        }
        if ((_a = window.speechstream) === null || _a === void 0 ? void 0 : _a.Loader) {
            window.speechstream.Loader.lateLoad();
        }
        return window.speechstream;
    };
    (0, react_1.useEffect)(function () {
        // if the window.speechstream object has a Loader function then it is configured for lateLoading, so we execute the late loader
        validateSpeechstreamIsActive();
    }, []);
    var active = !!((_b = window.speechstream) === null || _b === void 0 ? void 0 : _b.speechTools);
    var play = function (elementId) {
        var speechstream = validateSpeechstreamIsActive();
        if (!speechstream) {
            // eslint-disable-next-line no-console
            console.error("Cannot Play: speechstream is undefined");
            return;
        }
        if (speechstream === null || speechstream === void 0 ? void 0 : speechstream.speechTools) {
            // Set the voice per language to sound more correct
            if (isSpanishContent) {
                document.documentElement.setAttribute("lang", "es");
                speechstream.speechTools.setVoice("Paulina");
            }
            else {
                document.documentElement.setAttribute("lang", "en");
                speechstream.speechTools.setVoice("Joanna");
            }
            if (speechstream.domControlTools) {
                var ignoreClasses = ".footer *, .sr-item-description, .mq-math-mode, [class^='lrn-accessibility-'], .sr-only, .visually-hidden, .no-audio, .test-title-text, .subtitle, .item-count, .timer, .lrn_sort_gripper, .lrn-choicematrix-column-title, .vjs-control-bar";
                var doc = window.document;
                var domControl = window.speechstream.domControlTools.getNewDomControl(doc);
                domControl.addIgnoreListQuerySelector(ignoreClasses);
            }
            if (elementId && !window.speechstream.speechTools.isPaused()) {
                window.speechstream.speechTools.speakElement(document.getElementById(elementId), true);
                setPlaying(true);
            }
            else {
                window.speechstream.speechTools.pause();
                setPlaying(false);
            }
        }
    };
    var pause = function () {
        var speechstream = validateSpeechstreamIsActive();
        if (!speechstream) {
            // eslint-disable-next-line no-console
            console.error("Cannot Pause: speechstream is undefined");
            return;
        }
        if (active && speechstream) {
            speechstream.speechTools.pause();
            setPlaying(false);
        }
    };
    var stop = function () {
        var speechstream = validateSpeechstreamIsActive();
        if (!speechstream) {
            // eslint-disable-next-line no-console
            console.error("Cannot Stop: speechstream is undefined");
            return;
        }
        if (active && speechstream) {
            speechstream.speechTools.stop();
            setPlaying(false);
        }
        else {
            // eslint-disable-next-line no-console
            console.error("cannot Stop: speechstream is undefined");
        }
    };
    var isSpeaking = function () {
        var speechstream = validateSpeechstreamIsActive();
        if (active && speechstream) {
            return speechstream.speechTools.isSpeaking();
        }
        return false;
    };
    var setVoice = function (voice) {
        var speechstream = validateSpeechstreamIsActive();
        if (!speechstream) {
            // eslint-disable-next-line no-console
            console.error("Cannot Pause: speechstream is undefined");
            return;
        }
        if (speechstream && speechstream.speechTools) {
            speechstream.speechTools.setVoice(voice);
        }
    };
    return {
        speechstream: window.speechstream,
        isAvailable: isAvailable,
        isPlaying: playing,
        play: play,
        pause: pause,
        stop: stop,
        isSpeaking: isSpeaking,
        setVoice: setVoice
    };
};
exports.default = useSpeechStream;
